import React from 'react';
import NavigationItem from './NavigationItem';
import NavigationItemDesktop from './NavigationItemDesktop';
import {checkWorkWearCustomer, fetchBudget, checkWorkWearlinkAndText} from '../Actions/WorkWear.action'

import { useSelector,useDispatch } from 'react-redux';
import { navigation } from '../Reducers/Navigation.reducer';

const Navigation = () => {
    const dispatch = useDispatch();
    dispatch(checkWorkWearCustomer())
    dispatch(fetchBudget())
    dispatch(checkWorkWearlinkAndText())
    
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const isWorkWearCustomer = useSelector(state => state.workWearReducer.validateWorkWear.isWorkWearCustomer)
    const budgetRemaining = useSelector(state => state.workWearReducer.budget.budgetRemaining)
    const workWearText = useSelector(state => state.workWearReducer.getWorkWearLink?.linkText ?? "");
    const workWearLink = useSelector(state => state.workWearReducer.getWorkWearLink?.linkUrl ?? "");
    const isExcludedFromBudget = useSelector(state => state.workWearReducer.budget?.isExcludedFromBudget);

    return (
        <>
            <NavigationItem links={contentLinks} budgetRemaining={budgetRemaining} isWorkWearCustomer={isWorkWearCustomer} workWearLink={workWearLink} workWearText={workWearText} isExcludedFromBudget={isExcludedFromBudget}/> 
            <NavigationItemDesktop links={contentLinks} budgetRemaining={budgetRemaining} isWorkWearCustomer={isWorkWearCustomer} workWearLink={workWearLink} workWearText={workWearText} isExcludedFromBudget={isExcludedFromBudget}/> 
        </>
    )
};

export default Navigation;
